// Case studies — Lincoln's real deployments. Each gets a card on the
// homepage grid and (for some) a full detail page.

export const CASE_STUDIES = [
  {
    slug: 'tutoring',
    tag: 'Tutoring',         region: 'Pakistan & Global',
    title: '1-on-1 tutoring at scale',
    desc: 'How Lincoln tutored 12,000 students across math, English, and science — with measurable lift on every learner.',
    metric: '+38pts avg.',   color: '#f0b80c', img: 'tutoring',
    photo: 'https://images.unsplash.com/photo-1531545514256-b1400bc00f31?w=900&auto=format&fit=crop&q=80',
  },
  {
    slug: 'malta',
    tag: 'Public Schools',   region: 'Malta',
    title: 'AI courses in Maltese high schools',
    desc: 'A nationwide rollout: every secondary school in Malta now teaches AI literacy through Lincoln.',
    metric: '47 schools',    color: '#2b6cd9', img: 'malta',
    photo: 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=900&auto=format&fit=crop&q=80',
  },
  {
    slug: 'us-vocational',
    tag: 'Vocational',       region: 'United States',
    title: 'Career-readiness for vocational training',
    desc: 'Lincoln powers personalized learning for trade-school students across California and Texas.',
    metric: '8,400 learners', color: '#22b572', img: 'us',
    photo: 'https://images.unsplash.com/photo-1565891741441-64926e441838?w=900&auto=format&fit=crop&q=80',
  },
  {
    slug: 'finland-glowie',
    tag: 'K-12 Tutoring',    region: 'Finland · Glowie',
    title: 'Glowie tutors Finnish high-schoolers',
    desc: 'After-school AI tutoring program reaching every Finnish municipality — first of its kind.',
    metric: '311 cities',    color: '#c97864', img: 'finland-glowie',
    photo: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=900&auto=format&fit=crop&q=80',
  },
  {
    slug: 'wef',
    tag: 'Global',           region: 'World Economic Forum',
    title: 'Training the next billion on AI',
    desc: "Lincoln was selected as WEF's AI literacy partner — making the curriculum free to every student.",
    metric: 'WEF partner',   color: '#0e1f36', img: 'wef',
    photo: 'https://images.unsplash.com/photo-1577896851231-70ef18881754?w=900&auto=format&fit=crop&q=80',
  },
  {
    slug: 'finland-ai',
    tag: 'AI Literacy',      region: 'Finland',
    title: "Finland's national AI program",
    desc: 'Lincoln teaches every Finnish school student the foundations of AI — in Finnish, Swedish, and English.',
    metric: 'All ages 7-18', color: '#7a3a8a', img: 'finland-ai',
    photo: 'https://images.unsplash.com/photo-1571260899304-425eee4c7efc?w=900&auto=format&fit=crop&q=80',
  },
];
